<template>
    <div>
        <v-container id="container--contact-cards" class="pa-0">
            <v-row v-if="skeloader" column justify-center align-center>
                <v-col v-for="i in 4" :key="i" cols="12" sm="6">
                    <v-card>
                        <v-skeleton-loader
                            class="card-skeleton"
                            type="article, actions"
                        ></v-skeleton-loader>
                    </v-card>
                </v-col>
            </v-row>
            <v-row
                v-else-if="noAddressFound"
                column
                justify-center
                align-center
            >
                <v-col cols="12" :sm="6" class="flex-grow-1">
                    <v-card
                        :class="
                            billingFormArray.length % 2 === 0 ||
                            $vuetify.breakpoint.xs
                                ? 'add-new-address-card-flat'
                                : 'add-new-address-card'
                        "
                        @click="setCurrentIndex(-1)"
                    >
                        <v-card-text>
                            <v-btn
                                absolute
                                dark
                                fab
                                color="#0063a6"
                                class="add-new-address-btn"
                            >
                                <fa
                                    :icon="['fal', 'plus']"
                                    class="fa-lg"
                                    style="color: #fff"
                                />
                            </v-btn>
                            <span
                                ><TranslatableStringComponent
                                    :tstring="{ string: 'addNewAddress' }"
                            /></span>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12"
                    ><TranslatableStringComponent
                        :tstring="{ string: 'noAddressesFound' }"
                /></v-col>
            </v-row>
            <v-row v-else class="flex-row flex-wrap">
                <v-col
                    v-for="(item, index) in billingFormArray"
                    :key="index"
                    cols="12"
                    sm="6"
                >
                    <v-card>
                        <div>
                            <v-card-title>
                                <v-container class="pa-0"
                                    ><v-row class="align-baseline"
                                        ><v-col
                                            cols="12"
                                            :sm="
                                                isReadOnly(item.name)
                                                    ? '11'
                                                    : '9'
                                            "
                                            class="py-0"
                                        >
                                            <ContactCardTitle
                                                :contact="item"
                                            /> </v-col
                                        ><v-col
                                            cols="12"
                                            :sm="
                                                isReadOnly(item.name)
                                                    ? '1'
                                                    : '3'
                                            "
                                            class="pa-0 d-flex justify-end"
                                        >
                                            <v-tooltip
                                                v-if="isReadOnly(item.name)"
                                                bottom
                                                max-width="500"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <fa
                                                        :icon="[
                                                            'fal',
                                                            'info-circle',
                                                        ]"
                                                        class="fa-sm mr-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    />
                                                </template>
                                                <span>
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'thisAddressIsReadOnly',
                                                        }"
                                                    />
                                                </span>
                                            </v-tooltip>
                                            <div v-else>
                                                <div
                                                    v-if="
                                                        !(
                                                            $vuetify.breakpoint
                                                                .mdAndUp ||
                                                            $vuetify.breakpoint
                                                                .smAndUp
                                                        )
                                                    "
                                                    class="d-flex"
                                                >
                                                    <fa
                                                        :icon="['fal', 'pen']"
                                                        class="fa-xs mr-6"
                                                        @click="
                                                            setCurrentIndex(
                                                                index
                                                            )
                                                        "
                                                    />
                                                    <fa
                                                        :icon="[
                                                            'fal',
                                                            'trash-alt',
                                                        ]"
                                                        class="fa-xs mx-3"
                                                        @click="
                                                            triggerDialog(item)
                                                        "
                                                    />
                                                </div>
                                                <div v-else class="d-flex">
                                                    <v-btn
                                                        class="mr-2 px-4"
                                                        color="primary"
                                                        text
                                                        small
                                                    >
                                                        <fa
                                                            :icon="[
                                                                'fal',
                                                                'pen',
                                                            ]"
                                                            class="fa-lg mr-2"
                                                            @click="
                                                                setCurrentIndex(
                                                                    index
                                                                )
                                                            "
                                                        />
                                                    </v-btn>

                                                    <v-btn
                                                        text
                                                        small
                                                        color="primary"
                                                    >
                                                        <fa
                                                            :icon="[
                                                                'fal',
                                                                'trash-alt',
                                                            ]"
                                                            class="fa-lg mr-2"
                                                            @click="
                                                                triggerDialog(
                                                                    item
                                                                )
                                                            "
                                                        />
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </v-col> </v-row
                                ></v-container>
                            </v-card-title>
                            <v-card-text
                                style="font-size: 14px; line-height: 1.3"
                                class="pb-0"
                            >
                                <ContactCardDetails :contact="item" />
                            </v-card-text>
                            <v-container
                                class="py-0"
                                style="background-color: rgba(0, 0, 0, 0.06)"
                            >
                                <v-row
                                    :no-gutters="
                                        !(
                                            $vuetify.breakpoint.mdAndUp ||
                                            $vuetify.breakpoint.smAndUp
                                        )
                                    "
                                >
                                    <v-col cols="6" class="pr-0">
                                        <v-radio-group
                                            v-model="selectedBillingAddressID"
                                            style="display: inline-block"
                                            class="mt-0"
                                            :hide-details="true"
                                            color="success"
                                        >
                                            <v-radio
                                                :value="item.id"
                                                :label="
                                                    localize('useForBilling')
                                                "
                                                hide-details="auto"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="6" class="pl-0">
                                        <v-radio-group
                                            v-model="selectedShippingAddressID"
                                            style="display: inline-block"
                                            class="mt-0"
                                            :hide-details="true"
                                        >
                                            <v-radio
                                                :value="item.id"
                                                :label="
                                                    localize('useForShipping')
                                                "
                                                hide-details="auto"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-card>
                </v-col>
                <v-col
                    v-if="billingFormArray && billingFormArray.length < 8"
                    cols="12"
                    :sm="6"
                    class="flex-grow-1"
                >
                    <v-card
                        :class="
                            billingFormArray.length % 2 === 0 ||
                            $vuetify.breakpoint.xs
                                ? 'add-new-address-card-flat'
                                : 'add-new-address-card'
                        "
                        @click="setCurrentIndex(-1)"
                    >
                        <v-card-text>
                            <v-btn
                                absolute
                                dark
                                fab
                                color="#0063a6"
                                class="add-new-address-btn"
                            >
                                <fa
                                    :icon="['fal', 'plus']"
                                    class="fa-lg"
                                    style="color: #fff"
                                />
                            </v-btn>
                            <span
                                ><TranslatableStringComponent
                                    :tstring="{ string: 'addNewAddress' }"
                            /></span>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row
                v-if="billingFormArray && billingFormArray.length >= 8"
                column
                justify-center
                align-center
            >
                <v-col cols="12">
                    <span
                        ><TranslatableStringComponent
                            :tstring="{ string: 'maxAddressesOnFile' }"
                    /></span>
                    <nuxt-link
                        :to="
                            getStaticLocalePath({
                                type: 'page',
                                slugName: 'contact',
                            })
                        "
                        ><TranslatableStringComponent
                            :tstring="{ string: 'pleaseContactUs' }"
                    /></nuxt-link>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="editableForm" :persistent="true" width="800px">
            <v-card>
                <FormContactCard
                    :iscontactcard="true"
                    :iseditable="true"
                    :cardobj="billingFormArray[currentActiveTabIndex]"
                    @setCurrentActiveTabIndex="setCurrentIndex($event)"
                />
            </v-card>
        </v-dialog>
        <v-dialog v-model="newForm" :persistent="true" width="800px">
            <v-card>
                <FormContactCard
                    v-if="newForm"
                    :iscontactcard="true"
                    :defaultemailid="webUser && webUser.email"
                    :iseditable="false"
                    @setCurrentActiveTabIndex="setCurrentIndex($event)"
                />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card>
                <v-progress-linear
                    v-if="loader"
                    indeterminate
                    color="#0063a6"
                ></v-progress-linear>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <TranslatableStringComponent
                        :tstring="{ string: 'removeThisContact' }"
                    />
                </v-card-title>
                <v-card-text>
                    <p>
                        <TranslatableStringComponent
                            :tstring="{
                                string: 'confirmRemoveFromContactCards',
                                variables: [
                                    {
                                        var: `${removableCard.nameFirst} ${removableCard.nameLast}`,
                                        tag: 'strong',
                                    },
                                ],
                            }"
                        />
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">
                        <TranslatableStringComponent
                            :tstring="{ string: 'keep' }"
                        />
                    </v-btn>
                    <v-btn
                        color="error"
                        text
                        @click="remove(removableCard.name, removableCard.id)"
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'remove' }"
                        />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ContactCardDetails from '~/components/ContactCardDetails'
import ContactCardTitle from '~/components/ContactCardTitle'
import FormContactCard from '~/components/forms/FormContactCard'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import handleSnackbar from '~/mixins/handleSnackbar'
import encodeFormData from '~/mixins/encodeFormData'
import { localize } from 'vee-validate'
export default {
    name: 'ContactCards',
    components: {
        ContactCardDetails,
        FormContactCard,
        ContactCardTitle,
        TranslatableStringComponent,
    },
    mixins: [encodeFormData, handleSnackbar],
    data() {
        return {
            isCart: false,
            isCheckout: true,
            dialog: false,
            currentActiveTabIndex: null,
            removableCard: false,
            loader: false,
            skeloader: true,
            contactList: [],
            editableForm: false,
            newForm: false,
        }
    },
    computed: {
        ...mapState('flag', ['isResetForm']),
        ...mapState('checkout', ['billingForm', 'billingFormArray']),
        ...mapState('auth', ['webUser']),
        ...mapState('cart', ['selectedShippingMethod']),
        ...mapGetters({
            subtotal: 'cart/fetchCartSubtotal',
            cartProducts: 'cart/fetchCartProducts',
            noAddressFound: 'checkout/noAddressFound',
            taxes: 'cart/fetchCartTaxTotal',
            shippingMethodException: 'checkout/shippingMethodException',
        }),
        showCheckoutButton() {
            return false
        },
        isContactCardLimit() {
            return this.billingFormArray.length < 8
        },
        selectedBillingAddressID: {
            get() {
                return this.$store.state.checkout.selectedBillingAddressID
            },
            set(value) {
                this.$store.commit(
                    'checkout/updateSelectedBillingAddressID',
                    value
                )
            },
        },
        selectedShippingAddressID: {
            get() {
                return this.$store.state.checkout.selectedShippingAddressID
            },
            set(value) {
                this.$store.commit(
                    'checkout/updateSelectedShippingAddressID',
                    value
                )
            },
        },
    },
    watch: {
        webUser(newVal, oldVal) {
            if (newVal) {
                this.getContacts()
                this.setDefaultAddressCards()
            }
        },
        selectedShippingAddressID(newVal) {
            if (
                newVal &&
                this.selectedShippingMethod === 'ground' &&
                this.shippingMethodException
            )
                this.$store.dispatch('cart/updateShipping', 'air2day')
            if (newVal && this.taxes > 0) {
                this.hitSnackbar(
                    { string: `selectedShippingAddressTaxableAlert` },
                    null,
                    'warning',
                    20000
                )
            }
        },
    },
    mounted() {
        if (this.webUser) {
            this.getContacts()
        }
        if (
            this.$route.params.slug === this.getSlug({ slugName: 'addresses' })
        ) {
            this.setDefaultAddressCards()
        }
    },
    methods: {
        resetForm() {
            this.$refs.contactForm.reset()
            requestAnimationFrame(() => {
                this.$refs.observer.reset()
            })
        },
        triggerDialog(item) {
            this.removableCard = item
            this.dialog = true
        },
        async remove(name, id) {
            this.loader = true
            const payload = {
                name,
                id,
            }
            await this.$store.dispatch('checkout/removeContact', payload)
            this.dialog = false
            this.loader = false
        },
        setCurrentIndex(index) {
            this.currentActiveTabIndex = index
            if (index === null) {
                this.editableForm = false
                this.newForm = false
                this.getContacts()
            } else if (index === -1) {
                this.newForm = true
            } else {
                this.editableForm = true
            }
        },
        async getContacts() {
            await this.$store.dispatch('checkout/getContacts')
            this.skeloader = false
        },
        setDefaultAddressCards() {
            if (
                this.webUser &&
                this.webUser.WebUserBillingContactId &&
                this.webUser.WebUserShippingContactId
            ) {
                this.$store.commit(
                    'checkout/updateSelectedBillingAddressID',
                    this.webUser.WebUserBillingContactId
                )
                this.$store.commit(
                    'checkout/updateSelectedShippingAddressID',
                    this.webUser.WebUserShippingContactId
                )
            }
        },
        isReadOnly(name) {
            // eslint-disable-next-line no-useless-escape
            const regEx = /\(W\d{10}\)/

            if (regEx.test(name)) {
                return false
            } else {
                return true
            }
        },
    },
}
</script>
<style lang="scss" scoped>
%address-card-shared {
    height: 100%;
    position: relative;
    border: 1px dashed;
    border: 1px dashed #616161;
    cursor: pointer;
}
.add-new-address-card {
    @extend %address-card-shared;
    .add-new-address-btn {
        top: 35%;
        left: 43%;
        z-index: 0;
    }
    span {
        position: absolute;
        font-size: 18px;
        top: 55%;
        left: 31%;
    }
}
.add-new-address-card-flat {
    @extend %address-card-shared;
    .v-card__text {
        padding: 0;
        height: 80px;
    }
    .add-new-address-btn {
        top: 50%;
        left: 15px;
        margin-top: -28px;
        z-index: 0;
    }
    span {
        position: absolute;
        font-size: 18px;
        top: 40%;
        left: 85px;
    }
}
.card-msg {
    color: $primary;
    font-size: 12px;
    line-height: 1rem;
}
</style>
